<template>
  <section class="gf-tabs">
    <div
      ref="links"
      class="gf-tabs__tab-links"
    >
      <slot name="links"></slot>
    </div>
    <div class="gf-tabs__common-content">
      <slot name="common-content"></slot>
    </div>
    <div
      ref="tabs"
      class="gf-tabs__tabs"
    >
      <slot name="tabs"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GfCustomTabs',
  mounted() {
    const links = this.$refs.links.querySelectorAll('a');
    const tabs = this.$refs.tabs.querySelectorAll('.gf-tabs__tabs-item');
    const activeClass = 'active';

    function removeClasses() {
      links.forEach((tab) => {
        tab.classList.remove(activeClass);
      });
      tabs.forEach((tab) => {
        tab.classList.remove(activeClass);
      });
    }

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        removeClasses();
        const anchor = e.target.getAttribute('href');
        const tab = document.querySelector(anchor);
        e.target.classList.add(activeClass);
        tab.classList.add(activeClass);
      });
    });
  }
};
</script>

<style lang="scss">
$this: '.gf-tabs';

#{$this} {
  #{$this}__tabs-item {
    display: none;

    &.active {
      display: block;
    }
  }
}
</style>
